import i18next from 'i18next';
import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';

import { setOneOrderSelected } from 'actions/returnProducts';
import { ReturnRow } from 'types/ReturnTable';
import { addWarning } from 'actions/Error';
import { RootState } from 'reducers';

export function setRowReasonID(
  row: ReturnRow,
  returnReasonID: ReturnRow['returnReasonID'],
): ThunkAction<Promise<void>, RootState, unknown, Action> {
  return async function thunk(dispatch) {
    dispatch(
      setOneOrderSelected(row.stableRowID, {
        ...row,
        returnReasonID,
      }),
    );
  };
}

export function toggleReturnRow(
  row: ReturnRow,
  globalReturnReason: string | undefined,
): ThunkAction<Promise<void>, RootState, unknown, Action> {
  return async function thunk(dispatch) {
    if (row.nonRefundable) {
      dispatch(
        addWarning(
          i18next.t('alerts:nonRefundableProductError', {
            name: row.itemName,
          }),
        ),
      );
      return;
    }
    dispatch(
      setOneOrderSelected(row.stableRowID, {
        ...row,
        selected: !row?.selected,
        // Deselect reason on deselect row
        returnReasonID: !row?.selected
          ? row?.returnReasonID ?? globalReturnReason
          : undefined,
        amount: row?.remainingAmount,
      }),
    );
  };
}
